import { useContext, useEffect } from "react";
import { FILTER_ERROR } from "../constants/errors";
import { FilterPreset } from "../interfaces/filters";
import { get } from "../api/util";
import useLocalStorageState from "use-local-storage-state";
import { FilterPresetsEventContext } from "../context/FiltersContext";
import { UserQueryContext } from "../context/UserContext";

export function useFilterPresets(contextType: FilterPreset["type"]) {
  const filterPresetsEvent = useContext(FilterPresetsEventContext);
  const { user } = useContext(UserQueryContext);

  const [order, setOrder] = useLocalStorageState<string[]>(
    `${contextType}FilterOrder`,
  );

  useEffect(() => {
    if (user?.id) {
      get<SoegefilterDTO[]>({
        query: `brugere/${user.id}/soegefiltre`,
      })
        .then((data) => {
          const filterPresets: FilterPreset[] = data.map((filterObj) => {
            return {
              ...filterObj,
              filter: JSON.parse(filterObj.filter),
            };
          });

          if (order) {
            filterPresets.sort((a, b) => {
              const indexOfA = order.indexOf(a.id);
              const indexOfB = order.indexOf(b.id);
              return indexOfA - indexOfB;
            });

            filterPresetsEvent({
              event: "set",
              filters: filterPresets,
            });

            // what is happening here??
            // const filteredSet = order
            //   .map((id) => filterPresets.find((item) => item.id === id))
            //   .filter(Boolean);

            // filterPresetsEvent({
            //   event: "set",
            //   filters: filteredSet.filter((item): item is FilterPreset =>
            //     Boolean(item)
            //   ),
            // });
          } else {
            setOrder(filterPresets.map((set) => set.id));
            filterPresetsEvent({
              event: "set",
              filters: filterPresets,
            });

            // filterPresetsEvent({
            //   event: "set",
            //   filters: filterPresets.filter((item): item is FilterPreset =>
            //     Boolean(item)
            //   ),
            // });
          }
        })
        .catch((error) => {
          console.error(error, FILTER_ERROR.message);
        });
    }
  }, [filterPresetsEvent, order, setOrder, user?.id]);
}
